module.exports = __webpack_public_path__ + "files/1a8fb2dc49e5c342df85f5715222b43c.png";